import { useTranslation } from "react-i18next";

const STATUS_CONFIG = {
  active:   { bg: "#e6f4ea", color: "#2e7d32" },
  inactive: { bg: "#fce8e6", color: "#c62828" },
  graduated:  { bg: "#fff8e1", color: "#b2a497" },
};

export const StudentStatusTag = ({ value }) => {
  const { t } = useTranslation();
  const key = value?.toLowerCase().trim() ?? "unknown";
  const { bg, color } = STATUS_CONFIG[key] ?? { bg: "#f0f0f0", color: "#555" };

  return (
    <span style={{ background: bg, color, padding: "3px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: 600 }}>
      {t(`students.status.${key}`)}
    </span>
  );
};